import React, { useState, useEffect } from 'react';
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope } from 'react-icons/fa';
import './Contact.css';

const Contact = () => {
  // --- PASTE YOUR GOOGLE WEB APP URL HERE ---
  const GOOGLE_SCRIPT_URL = "https://script.google.com/macros/s/AKfycbxCiz6c25G_RRL-ueTVCLKf325z7beJj532EAaeVgKTH9WCI9ysU-CVitj7HGITJRrZ/exec";

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });

  // 'idle', 'submitting', 'success', 'error'
  const [status, setStatus] = useState('idle');

  // --- CAPTCHA STATE ---
  const [captcha, setCaptcha] = useState({ num1: 0, num2: 0, userAnswer: '' });
  const [captchaError, setCaptchaError] = useState(false);

  // Generate CAPTCHA on component load
  useEffect(() => {
    generateCaptcha();
  }, []);

  const generateCaptcha = () => {
    setCaptcha({
      num1: Math.floor(Math.random() * 10) + 1,
      num2: Math.floor(Math.random() * 10) + 1,
      userAnswer: ''
    });
    setCaptchaError(false);
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // 1. CAPTCHA CHECK
    const correctAnswer = captcha.num1 + captcha.num2;
    // Ensure userAnswer is parsed as an integer for comparison
    if (parseInt(captcha.userAnswer, 10) !== correctAnswer) {
        setCaptchaError(true);
        // Regenerate captcha to prevent brute forcing
        generateCaptcha();
        return;
    }

    setStatus('submitting');

    // 2. Prepare data for Google Script
    const data = new FormData();
    data.append('name', formData.name);
    data.append('email', formData.email);
    data.append('phone', formData.phone);
    data.append('subject', formData.subject);
    data.append('message', formData.message);

    // 3. Send data via Fetch
    fetch(GOOGLE_SCRIPT_URL, {
        method: 'POST',
        body: data,
        mode: 'no-cors' // Important for Google Apps Script requests
    })
    .then(() => {
        setStatus('success');
        setFormData({ name: '', email: '', phone: '', subject: '', message: '' });
        generateCaptcha(); // Reset Captcha for next time
    })
    .catch((error) => {
        console.error('Error!', error.message);
        setStatus('error');
        generateCaptcha();
    })
    .finally(() => {
         // Clear success/error message after 5 seconds
         if (status === 'success' || status === 'error') {
            setTimeout(() => setStatus('idle'), 5000);
         }
    });
  };

  return (
    <div className="contact-page">
      <div className="container">
        <div className="contact-header">
          <h1>Get in Touch</h1>
          <p>Have a project in mind or need a quote? Fill out the form below and our team will get back to you shortly.</p>
        </div>

        <div className="contact-grid">
          {/* Left Column - Contact Info (Unchanged) */}
          <div className="contact-info-column">
            <div className="contact-info-item">
              <FaMapMarkerAlt className="contact-icon" />
              <div className="contact-details">
                <h3>Our Office</h3>
                <p>212/A, 3rd Floor, 3E, 1st Main Road,<br /> Domlur 2nd, Bangalore North,<br /> Bangalore- 560071, Karnataka</p>
              </div>
            </div>
            <div className="contact-info-item">
              <FaEnvelope className="contact-icon" />
              <div className="contact-details">
                <h3>Email Us</h3>
                <a href="mailto:info@tronixai.com">info@tronixai.com</a>
              </div>
            </div>
            <div className="contact-info-item">
              <FaPhoneAlt className="contact-icon" />
              <div className="contact-details">
                <h3>Call Us</h3>
                <a href="tel:+918895605589">+91 8895605589</a>
              </div>
            </div>
          </div>

          {/* Right Column - Contact Form */}
          <div className="contact-form-column">
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label className="form-label">Full Name *</label>
                <input type="text" name="name" value={formData.name} onChange={handleChange} className="form-input" required />
              </div>

              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
                <div className="form-group">
                    <label className="form-label">Email Address *</label>
                    <input type="email" name="email" value={formData.email} onChange={handleChange} className="form-input" required />
                </div>
                <div className="form-group">
                    <label className="form-label">Phone Number</label>
                    <input type="tel" name="phone" value={formData.phone} onChange={handleChange} className="form-input" />
                </div>
              </div>

              <div className="form-group">
                <label className="form-label">Subject *</label>
                <select name="subject" value={formData.subject} onChange={handleChange} className="form-input" required>
                    <option value="">Select a Subject</option>
                    <option value="Get a Quote">Get a Quote</option>
                    <option value="General Inquiry">General Inquiry</option>
                    <option value="AI & Software Services">AI & Software Services</option>
                    <option value="Engineering & Construction">Engineering & Construction</option>
                    <option value="Partnership">Partnership</option>
                </select>
              </div>

              <div className="form-group">
                <label className="form-label">Message *</label>
                <textarea name="message" value={formData.message} onChange={handleChange} className="form-textarea" required></textarea>
              </div>

              {/* --- CAPTCHA FIELD --- */}
              <div className="form-group" style={{backgroundColor: '#f9f9f9', padding: '15px', borderRadius: '8px', border: captchaError ? '1px solid red' : '1px solid #e0e0e0'}}>
                  <label className="form-label" style={{marginBottom: '10px', display: 'block'}}>
                      Verify you are human: {captcha.num1} + {captcha.num2} = ?
                  </label>
                  <input
                      type="number"
                      required
                      value={captcha.userAnswer}
                      onChange={(e) => setCaptcha({ ...captcha, userAnswer: e.target.value })}
                      className="form-input"
                      style={{width: '100px', display: 'inline-block', marginRight: '10px'}}
                      placeholder="?"
                  />
                  {captchaError && (
                    <span style={{color: 'red', fontSize: '0.9rem', fontWeight: '500'}}>Incorrect math answer.</span>
                  )}
              </div>


              <button type="submit" className="btn btn-gradient" disabled={status === 'submitting'} style={{ width: '100%' }}>
                {status === 'submitting' ? 'Sending...' : 'Send Message'}
              </button>

               {/* Feedback Messages */}
               {status === 'success' && (
                  <p style={{ color: 'green', marginTop: '15px', fontWeight: '500', textAlign: 'center' }}>
                    Thank you! Your message has been sent successfully. Someone will get back to you shortly.
                  </p>
                )}
                {status === 'error' && (
                  <p style={{ color: 'red', marginTop: '15px', fontWeight: '500', textAlign: 'center' }}>
                    Something went wrong. Please try again later.
                  </p>
                )}

            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;